import {BatchComparisonKeysDto} from '../dto/batch-comparison.dto';
import {BatchComparisonKey} from './../../models/batch-comparison';

export function convertBatchComparisonKeyDtoToModel(dto: BatchComparisonKeysDto): BatchComparisonKey {
  return {
    batchNumber: dto.BatchNumber,
    label: dto.Label,
  };
}
